module.exports = __webpack_public_path__ + "static/img/spaceship.bd76477.svg";


//////////////////
// WEBPACK FOOTER
// ./src/common/notfound/image/spaceship.svg
// module id = wZqA
// module chunks = 39